// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatScreenSkeleton_wrapper__y2-7X"};